import type { KaiEntityTagKind } from "./kaiEntityTags";
import type { KaiSlashCommand } from "@/services/kaiApi";

/** `@` tag kinds allowed for Client (consignee portal) users. */
export const CLIENT_ALLOWED_ENTITY_TAG_KINDS: readonly KaiEntityTagKind[] = [
  "carrier",
  "port",
  "booking_state",
];

const CLIENT_ALLOWED_TAG_KIND_SET = new Set<KaiEntityTagKind>(
  CLIENT_ALLOWED_ENTITY_TAG_KINDS,
);

/** Slash command ids hidden from Client users (mirrors Kai server registry). */
export const CLIENT_BLOCKED_SLASH_COMMAND_IDS = new Set([
  "ops-pending-book",
  "rates",
  "rates-catchup",
  "rates-upload",
  "quote",
  "rebook",
  "rebook-top",
  "my-consignees",
  "feed-filter",
  "emails-review",
  "show-documents",
  "restrictions",
  "home",
  "dashboard",
  "scheduled-reports",
  "my-booking-reports",
]);

export function isClientAllowedEntityTagKind(
  kind: KaiEntityTagKind,
): boolean {
  return CLIENT_ALLOWED_TAG_KIND_SET.has(kind);
}

export function filterSlashCommandsForClient(
  commands: KaiSlashCommand[],
  isClient: boolean,
): KaiSlashCommand[] {
  if (!isClient) return commands;
  return commands.filter((c) => !CLIENT_BLOCKED_SLASH_COMMAND_IDS.has(c.id));
}
